var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page-not-found-container"},[_c('h1',[_vm._v(_vm._s(_vm.$t('shared.page_not_found.text')))]),_c('v-btn',{staticClass:"back-to-menus-btn",on:{"click":_vm.backToMenus}},[_vm._v(" "+_vm._s(_vm.$t('shared.page_not_found.btn_back'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }